import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { LicenseLimitExceededReason } from "../interface";
import { licenseLimitExceededReason } from "../schema";

export class LicenseLimitExceededVO {
  private static configValidation = JsonSchemaValidator.compile(
    LicenseLimitExceededVO.configValidationSchema()
  );

  constructor(readonly value: LicenseLimitExceeded) {
    JsonSchemaValidator.assert(LicenseLimitExceededVO.configValidation, value);
  }

  toJSON() {
    return this.value;
  }

  private static configValidationSchema() {
    return {
      type: "object",
      required: ["roomId", "reason"],
      properties: {
        roomId,
        reason: licenseLimitExceededReason
      },
      additionalProperties: false
    };
  }
}

interface LicenseLimitExceeded {
  roomId: RoomId;
  reason: LicenseLimitExceededReason;
}
